<template>
    <div class="examine min-height">
        <div class="flex align-center justify-between margin-bottom">
            <div class="flex align-center ">
                <el-input placeholder="请输入企业名称/社会统一信用代码/联系人姓名" v-model="searchName" style="width: 350px;"></el-input>

                <el-date-picker
                    v-model="endTime"
                    class="margin-left-sm"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>

                <el-select v-model="apply" placeholder="请选择审核进度" class="margin-left-sm">
                    <el-option
                        v-for="item in examineList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>


                <el-button type="primary" class="margin-left-sm" @click="search">搜索</el-button>
            </div>
        </div>

        <el-table
            :data="tableData"
            header-row-class-name="table-header"
            row-class-name="table-row"
            alig="center"
            border
            style="width: 100%">
            <el-table-column
                type="index"
                label="序号"
                width="80">
            </el-table-column>
            <el-table-column
                prop="company_name"
                label="企业全称"
            >
            </el-table-column>
            <el-table-column
                prop="company_code"
                label="社会统一信用代码">
            </el-table-column>
            <el-table-column
                prop="unit_nature"
                label="单位性质">
            </el-table-column>
            <el-table-column
                prop="member_classification"
                label="会员等级">
            </el-table-column>
            <el-table-column
                prop="member_give_classification"
                label="会员供需分类">
            </el-table-column>
            <el-table-column
                prop="tel_name"
                label="联系人姓名">
            </el-table-column>
            <el-table-column
                prop="tel_number"
                label="联系人电话">
            </el-table-column>
            <el-table-column
                prop="audit_type"
                label="申请类型">
                <template slot-scope="scope">
                    <span v-if=" scope.row.t_state === 2" style="color: #0d7fd7; cursor: pointer;"
                          @click="showCancellation(scope.row.cancellation)">注销(查看原因)</span>
                    <span v-else>{{ scope.row.audit_type }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="状态">
                <template slot-scope="scope">
                    <!--                    <span v-if=" scope.row.status === 0">待审核</span>-->
                    <!--                    <span v-if=" scope.row.status === 1">已通过</span>-->
                    <!--                    <span v-if=" scope.row.status === 2  && user.user_role !== scope.row.state" style="cursor: pointer;"-->
                    <!--                          @click="showReason(scope.row.reject_reason)">已驳回-->
                    <!--                        <br><i style="color: #0d7fd7;">(查看原因)</i>-->
                    <!--                    </span>-->
                    <!--                    <span v-if=" scope.row.status === 2 && user.user_role === scope.row.state" style="cursor: pointer;"-->
                    <!--                          @click="showReason(scope.row.reject_reason)">上级驳回待审核-->
                    <!--                        <br><i style="color: #0d7fd7;">(查看原因)</i>-->
                    <!--                    </span>-->
                    {{ scope.row.statue_type }}
                    <br><i v-if=" scope.row.status === 2" style="color: #0d7fd7;cursor: pointer;"
                           @click="showReason(scope.row.reject_reason)">(查看原因)</i>
                </template>
            </el-table-column>
            <el-table-column
                width="200px"
                label="操作">
                <template slot-scope="scope">
                    <router-link :to="'/admin/examineDetail/' + scope.row.user_id +'?id=' + scope.row.id">
                        <el-button type="text" class="font-size-sm">查看</el-button>
                    </router-link>
                    <router-link :to="'/admin/examineEdit/' + scope.row.user_id" v-if="user.user_role === 1" class="margin-left-sm">
                        <el-button type="text" class="font-size-sm">编辑</el-button>
                    </router-link>

                    <el-button type="text" class="font-size-sm margin-left-sm" @click="getAuditLog(scope.row.user_id)">
                        审批记录
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            v-if="tableData.length > 0"
            class="page-all"
            background
            @current-change="getList"
            :current-page.sync="page"
            :page-size="limit"
            layout="prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>


        <el-drawer
            title=""
            :visible.sync="drawer"
            :with-header="false">
            <div class="padding">
                <el-timeline>
                    <el-timeline-item v-for="(item,index) in list" :key="index" :timestamp="item.create_time"  placement="top">
                        <el-card v-if="item.state === 1">
                            <h4>新申请提交成功，经办人审核中</h4>
                            <br>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 3|| item.state === 12">
                            <h4>{{item.renew === 1?'续费申请,':''}}审核人审核中</h4><br>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 5|| item.state === 14">
                            <h4>{{item.renew === 1?'续费申请,':''}}审批人审核中</h4><br>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 2 || item.state === 11">
                            <h4>经办人驳回</h4><br>
                            <p style="color: #9a0000">驳回原因：{{ item.message }}</p><br>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 4|| item.state === 13">
                            <h4>审核人驳回</h4><br>
                            <p style="color: #9a0000">驳回原因：{{ item.message }}</p><br>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 6|| item.state === 15">
                            <h4>审批人驳回</h4><br>
                            <p style="color: #9a0000">驳回原因：{{ item.message }}</p><br>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 7|| item.state === 17">
                            <h4>{{item.renew === 1?'续费申请,':''}}信息审核通过，待缴费</h4>
                            <br>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 8|| item.state === 18">
                            <h4>待领取</h4>
                            <br>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 9|| item.state === 19">
                            <h4>已领取</h4>
                            <br>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 10">
                            <h4>信息提交成功，经办人审核中</h4>
                            <br>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                        <el-card v-if="item.state === 16">
                            <h4>审批通过，信息修改成功</h4>
                            <br>
                            <p>{{ item.create_time }}</p>
                        </el-card>
                    </el-timeline-item>

                </el-timeline>
            </div>
        </el-drawer>
    </div>
</template>

<script>

import {getExamineList} from "@/api/admin";
import {zhDate,examineList} from "@/utils/utils";
import {auditLog} from "@/api/member";

export default {
    name: "examine",
    data() {
        return {
            searchName: '',
            endTime: null,
            page: 1,
            limit: 10,
            total: 0,
            tableData: [],
            drawer: false,
            list: [],
            apply:'',
            examineList:examineList
        }
    },
    created() {
        this.$emit("setIndex", this.$route.path, "会员审核  / ", false, 'icon-jibenxinxi1');
        this.apply = this.$store.state.user.user_role
        this.getList()
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    components: {},
    methods: {
        async getAuditLog(id) {
            let _list = await auditLog(id)
            this.drawer = true
            this.list = _list.data
        },
        //  显示注销原因
        showCancellation(str) {
            this.$alert(str, '注销原因', {
                confirmButtonText: '确定',
                center: true,
                callback: () => {

                }
            });
        },
        //  显示驳回原因
        showReason(str) {
            this.$alert(str, '驳回原因', {
                confirmButtonText: '确定',
                center: true,
                callback: () => {

                }
            });
        },
        search() {
            this.page = 1
            this.getList()
        },
        //  获取列表
        async getList() {
            let _list = await getExamineList(this.searchName,
                this.endTime && this.endTime.length > 0 ? zhDate(new Date(this.endTime[0])) + '~' + zhDate(new Date(this.endTime[1])) : ''
                , this.page, this.limit,this.apply)
            this.tableData = _list.data.data
            this.total = _list.data.total
        },
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">
.examine {
    background: #fff;
    padding: 30px;
    border-radius: 8px;
}
</style>